import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Form, Input, Tooltip } from 'antd';
import { EditableContext } from './Portfolio';
import { formatDate } from '../../helpers/formatDate';
import CustomSelect from '../CustomSelect/CustomSelect';
import CustomInputNumber from '../CustomInputNumber/CustomInputNumber';
import { decimalSeparator as decFunc} from '../../helpers/decimalSeparator';
import { formatter, parser, parserINT } from '../../helpers/formatterInput';

const EditableCellUnlisted = ({
  editing,
  children,
  dataIndex,
  record,
  handleSave,
  setTarget,
  assets,
  ...restProps
}) => {
  // const dispatch = useDispatch();
  const { t } = useTranslation('');
  const form = useContext(EditableContext);
  const decimalSeparator = decFunc();

  useEffect(() => {
    if (dataIndex) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  }, [dataIndex]);
  const systemName = ['PRIVATA_BOLAG', 'PRIVATE_EQUITY', 'FASTIGHETER', 'SKOG'];

  const getAssetClassUnlisted = useMemo(() => {
    if(assets) {
      const classArray = assets?.filter(i =>systemName
        .includes(i.sysName)).map(el => ({value:el.ID, label: (el.name)}));
        console.log('🚀 ~ EditableCellUnlisted ~ classArray:', classArray);
        return classArray;
    } else {
      return [];
    }
    }, [assets]);

  const save = async () => {
    try {
      const values = await form.getFieldsValue();
      if (['unitsNumber', 'latest_value_sek'].includes(dataIndex)) {
        handleSave({
          ...record,
          ...values,
          value: values.units_number * values.latest_value_sek,
        });
      } else {
        handleSave({
          ...record,
          ...values,
          value: values.units_number * values.latest_value_sek,
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  if (editing) {
    return (
      <td {...restProps}>
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
        >
          {['units_number', 'latest_value_sek'].includes(dataIndex)
            ? (
            <CustomInputNumber
              decimalSeparator={decimalSeparator}
              className='custom-inputnumber'
              style={{ width: '100%' }}
              min={0}
              precision={dataIndex === 'units_number' ? 0 : 2}
              onBlur={save}
              onChange={save}
              onStep={save}
              onPressEnter={save}
              placeholder={record[dataIndex]}
              formatter={formatter}
              parser={dataIndex === 'latest_value_sek' ? parser : parserINT}
            />
              )
            : dataIndex === 'name'
              ? (
            <Input
              className='custom-input full-width'
              type="text"
              placeholder={t('ENTER_THE_NAME')}
              onInput={save}
            />
                )
              : (
            <CustomSelect
              width='280px'
              className="custom-select"
              placeholder={t('SELECT_OPTION')}
              type="select"
              onSelect={save}
              options={getAssetClassUnlisted}
            />
            )}
        </Form.Item>
      </td>
    );
  } else {
    return dataIndex !== 'latest_value_sek'
      ? (
      <td {...restProps} onClick={setTarget}>
        {children}
      </td>
        )
      : (
      <Tooltip
        placement="top"
        title={
          <span style={{ color: '#000000' }}>
            {formatDate(record?.latest_value_time)}
          </span>
        }
        color="white"
      >
        <td {...restProps} onClick={setTarget}>
          {children}
        </td>
      </Tooltip>
        );
  }
};

export default EditableCellUnlisted;

EditableCellUnlisted.propTypes = {
  title: PropTypes.node,
  editing: PropTypes.bool,
  children: PropTypes.node,
  dataIndex: PropTypes.string,
  record: PropTypes.object,
  handleSave: PropTypes.func,
  setTarget: PropTypes.func,
  data: PropTypes.array,
  assets: PropTypes.array,
};
